module.exports = __webpack_public_path__ + "img/bnr_lesson_pc.3d55ebe2.png";